/* eslint-disable max-len */

export const cancelInfo = [
    'Para compras realizadas no cartão de crédito: o cancelamento e reembolso do valor acontece de forma imediata',
    'Para compras realizadas no PIX ou Boleto que ainda não foram pagas: o cancelamento acontece de forma imediata',
    'Para compras realizadas via PIX ou Boleto já pagas: o valor da sua compra será creditado na sua carteira de créditos para usar em compras no Reward Hub ou solicitar o saque para a sua conta bancária.',
];
